import * as React from "react";
import t from "../i18n/en";
import IndexPage from "../components/IndexPage";

const English = () => {
  return <IndexPage t={t} lang="en" />;
};

export default English;
